import { useEffect } from 'react';

import { useBreakPoints, usePlatformService } from 'core/Hooks';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { LoadingOverlay } from 'ui';

import { useOnboardingReferrals } from '../../components/auth/hooks';
import { ReferralLayout } from './ReferralLayout';

export const Peer = () => {
  const Platform = usePlatformService();
  const { isDesktop, isMobile } = useBreakPoints();
  const navigate = useNavigate();
  const { code } = useParams<{ code: string }>();
  const { useGetUserReferral } = useOnboardingReferrals();

  const { data: referral, isLoading, isError } = useGetUserReferral(code);

  useEffect(() => {
    if (isError) {
      navigate('/sign-up');
    }
  }, [isError]);

  if (isLoading) {
    return <LoadingOverlay visible={true} />;
  }

  if (Platform.isNative) {
    return <Navigate to="/native/get-started" />;
  } else if (isDesktop) {
    return <ReferralLayout.Desktop />;
  } else if (isMobile) {
    return <ReferralLayout.Mobile cause={referral?.cause} referral={referral} />;
  }

  return <ReferralLayout.Mobile cause={referral?.cause} referral={referral} />;
};
